import { toast } from '@/hooks/use-toast';
import { mfaConfirm, mfaDisable, mfaEnroll, mfaRegenerateRecoveryCodes, mfaStatus } from '@/lib/api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
// Status drives the enrollment panel; refetched after every state-changing mutation.
export function useMfaStatus() {
    return useQuery({
        queryKey: ['mfaStatus'],
        queryFn: mfaStatus,
    });
}
export function useMfaEnroll() {
    const { t } = useTranslation();
    return useMutation({
        mutationFn: mfaEnroll,
        onError: () => {
            toast({
                title: t('account.mfa.errorTitle'),
                description: t('account.mfa.enrollError'),
                variant: 'destructive',
            });
        },
    });
}
export function useMfaConfirm() {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (code) => mfaConfirm(code),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['mfaStatus'] });
        },
        onError: (error) => {
            const description = error.message.includes('Invalid')
                ? t('account.mfa.invalidCodeError')
                : t('account.mfa.confirmError');
            toast({ title: t('account.mfa.errorTitle'), description, variant: 'destructive' });
        },
    });
}
export function useMfaDisable() {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (currentPassword) => mfaDisable(currentPassword),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['mfaStatus'] });
            toast({
                title: t('account.mfa.disabledTitle'),
                description: t('account.mfa.disabledToast'),
            });
        },
        onError: (error) => {
            const description = error.message.includes('incorrect')
                ? t('account.mfa.incorrectPasswordError')
                : t('account.mfa.disableError');
            toast({ title: t('account.mfa.errorTitle'), description, variant: 'destructive' });
        },
    });
}
export function useMfaRegenerateRecoveryCodes() {
    const { t } = useTranslation();
    return useMutation({
        mutationFn: (currentPassword) => mfaRegenerateRecoveryCodes(currentPassword),
        onError: (error) => {
            const description = error.message.includes('incorrect')
                ? t('account.mfa.incorrectPasswordError')
                : t('account.mfa.regenerateError');
            toast({ title: t('account.mfa.errorTitle'), description, variant: 'destructive' });
        },
    });
}
